import { JwtPayload } from '@aws-amplify/core/internals/utils';
import { CurrentUser, Role } from 'src/AppContext';
import { ModuleIdInCognito } from 'src/graphql/mappers/module';
import { mapCognitoIdToProductLine } from 'src/viewModels/Products';

export const mapToCurrentUser = (idToken: JwtPayload, modules: Array<string>): CurrentUser => {
    // Add ColorProofGO if not there, because it should be always shown
    const CPGOId: ModuleIdInCognito = 'ColorProofGO';
    const assignedModulesInCognito = Array.isArray(idToken['cognito:groups'])
        ? idToken['cognito:groups'] as Array<ModuleIdInCognito>
        : [];
    const modulesInCognito = [...new Set([...assignedModulesInCognito, CPGOId])];

    const productToShow = modulesInCognito
        .filter(m => modules.includes(m))
        .map(m => mapCognitoIdToProductLine(m))
        .sort((a, b) => a.localeCompare(b));
    const result: CurrentUser = {
        // User name, org ID, and role will be undefined if user was not added to an organization yet.
        firstName: (idToken.given_name as string || '').trim(),
        lastName: (idToken.family_name as string || '').trim(),
        userId: idToken['custom:user_id'] as string,
        email: idToken.email as string,
        orgId: idToken.organization_id as string,
        orgName: idToken.organization_name as string,
        ...(idToken.invited_to_organization_id && { orgIdFromInvitation: idToken.invited_to_organization_id as string }),
        ...(idToken.invited_to_organization_name && { orgNameFromInvitation: idToken.invited_to_organization_name as string }),
        role: idToken.role as Role,
        modules: productToShow, // Should we renamed modules to sg ?
    };

    return result;
};